/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilityprivate2Inputs */

const en_eventvisibilityprivate2 = /** @type {(inputs: Eventvisibilityprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private, link only`)
};

const de_eventvisibilityprivate2 = /** @type {(inputs: Eventvisibilityprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat, nur mit Link`)
};

/**
* | output |
* | --- |
* | "Private, link only" |
*
* @param {Eventvisibilityprivate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilityprivate2 = /** @type {((inputs?: Eventvisibilityprivate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilityprivate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilityprivate2(inputs)
	return de_eventvisibilityprivate2(inputs)
});
export { eventvisibilityprivate2 as "eventVisibilityPrivate" }